export const paths = {
  index: "/",
  terms: "/terms",
  privacy: "/privacy",
  auth: {
    jwt: {
      login: "/auth/jwt/login",
      register: "/auth/jwt/register",
      verify: "/auth/jwt/verify",
      forgot: "/auth/jwt/forgot",
      forgotVerify: "/auth/jwt/forgot-verify",
      reset: "/auth/jwt/reset",
      kakaoCallback: "/auth/jwt/kakao-callback",
      naverCallback: "/auth/jwt/naver-callback",
      googleCallback: "/auth/jwt/google-callback",
    },
  },
  dashboard: {
    index: "/dashboard/home",
    home: "/dashboard/home",
    test: {
      index: "/dashboard/test",
      marketWeeklyAdvanced: "/dashboard/test/market-weekly-advanced",
      graph: {
        mixed: "/dashboard/test/graph/mixed",
        scatter: "/dashboard/test/graph/scatter",
        nivoLine: "/dashboard/test/graph/nivo-line",
        highchartTileMap: "/dashboard/test/graph/highchart-tilemap",
        highchartHeatMap: "/dashboard/test/graph/highchart-heatmap",
        highchartSyncronized: "/dashboard/test/graph/highchart-syncronized",
        highchartOverlayColumns:
          "/dashboard/test/graph/highchart-overlay-columns",
      },
      map: {
        geoMap: "/dashboard/test/map/geo-map",
        naverMap: "/dashboard/test/map/naver-map",
        regionMap: "/dashboard/test/map/region-map",
      },
      component: {
        regionFilter: "/dashboard/test/component/region-filter",
        gunguGroupFilter: "/dashboard/test/component/gungu-group-filter",
        datalake: "/dashboard/test/component/test-datalake",
        customTable: "/dashboard/test/component/custom-table",
        datatable: "/dashboard/test/component/datatable",
      },
      layout: {
        fullLayout: "/dashboard/test/layout/full-layout",
      },
    },
    admin: {
      userlist: "/dashboard/admin/userlist",
      collectors: "/dashboard/admin/collector-list",
      collectionInfo: "/dashboard/admin/collection-info",
      fails: "/dashboard/admin/fails",
      serverLogs: "/dashboard/admin/server-logs",
      aptMatch: "/dashboard/admin/apt-match",
      systemDashboard: "/dashboard/admin/system",
      blog: "/dashboard/admin/blog",
      coupons: "/dashboard/admin/coupons",
      notices: "/dashboard/admin/notices",
      community: "/dashboard/admin/community",
      recommendationThemes: "/dashboard/admin/recommendation-themes",
      priceOutliers: "/dashboard/admin/price-outliers",
      datalakeCollector: "/dashboard/admin/datalake-collector",
      stocks: "/dashboard/admin/stocks",
      regionMatch: "/dashboard/admin/region-match",
      mismatchManage: "/dashboard/admin/mismatches",
    },
    regions: {
      favorite: "/dashboard/regions/favorite",
      info: "/dashboard/regions/info",
      info2: "/dashboard/regions/info2",
      newwindow: "/dashboard/regions/newwindow",
    },
    mregion: {
      analyze: "/dashboard/mregion/analyze",
    },
    rregion: {
      analyze: "/dashboard/rregion/analyze",
      screening: "/dashboard/rregion/screening",
      compare: "/dashboard/rregion/compare",
      risk: "/dashboard/rregion/risk",
      priceDist: "/dashboard/rregion/price-distribution",
    },
    apts: {
      index: "/dashboard/apts",
      investment: "/dashboard/apts/investment",
      info: "/dashboard/apts/info",
      select: "/dashboard/apts/select",
      undervalue: "/dashboard/apts/undervalue",
      upside: "/dashboard/apts/upside",
      bargain: "/dashboard/apts/bargain",
      newHighDrop: "/dashboard/apts/new-high-drop",
      selectmap: "/dashboard/apts/selectmap",
      group: "/dashboard/apts/group",
      newwindow: "/dashboard/apts/newwindow",
      pyeongNewwindow: "/dashboard/apts/pyeong-newwindow",
    },
    condition: {
      nationRanking: "/dashboard/condition/nation-ranking",
      mainRegionIndex: "/dashboard/condition/mainregion-index",
      mainRegionMonthly: "/dashboard/condition/mainregion-monthly",
      marketOpportunityStatus: "/dashboard/condition/market-opportunity",
      sidoMainIndex: "/dashboard/condition/sido-mainindex",
      sidoPriceIndex: "/dashboard/condition/sido-priceindex",
      sidoMarketIndex: "/dashboard/condition/sido-marketindex",
      sidoTimeSeries: "/dashboard/condition/sido-timeseries",
      gunguMainIndex: "/dashboard/condition/gungu-mainindex",
      gunguTimeSeries: "/dashboard/condition/gungu-timeseries",
      cycle: "/dashboard/condition/cycle",
    },
    analyze: {
      sido: "/dashboard/analyze/sido",
      gungu: "/dashboard/analyze/gungu",
      multi: "/dashboard/analyze/multi",
      list: "/dashboard/analyze/list",
      notes: "/dashboard/analyze/notes",
      noteNewWindow: "/dashboard/analyze/note-newwindow",
      noteFolderWindow: "/dashboard/analyze/note-folder-window",
      newwindow: "/dashboard/analyze/newwindow",
    },
    pricing: {
      index: "/dashboard/pricing",
    },
    mypage: "/dashboard/mypage",
    community: {
      index: "/dashboard/community",
    },
    guide: {
      proplake: "/dashboard/guide/proplake",
      sources: "/dashboard/guide/data-sources",
    },
    settings: {
      layout: "/dashboard/settings/layout",
    },
  },
  401: "/401",
  404: "/404",
  500: "/500",
  naver: "https://new.land.naver.com/complexes/",
};
